/* eslint-disable max-len */
import Image from "next/image";
import Link from "next/link";

import { ROUTES } from "@/helpers/routes";
import PageSeo from "@/shared/components/PageSeo";

import Layout from "../../shared/components/layout";

export default function HeadlineSponsorsDetails2() {

    return (
        <div>
            <PageSeo title="Goldman Sachs | The Gender Index" pathname={ROUTES.headlineSponsorsGoldmanSachs} />
            <Layout>
                <div className='singleLayout partnerDetailsPage'>
                    <div className='edgeBannerWrapper'>
                        <div className='edgeBanner'>
                        </div>
                        <div className="bannerDetailsWrap">
                            <div className="leftPane">
                                <Link className="backBtn" href="/headline-sponsors">&lt; Back</Link>
                                <h4>Headline sponsor</h4>
                                <h1>Goldmans Sachs</h1>
                                <ul className="commonList link">
                                    <li>@GoldmanSachs</li>
                                    <li>@GoldmanSachs</li>
                                    <li>@GS10KSmallBiz</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="logo-image natwest">
                        {/* <img src="/images/PartnerLogos/goldman-new.jpg" alt="logo_image" /> */}
                        <Image
                            src="/images/PartnerLogos/goldman-new.jpg"
                            alt="logo_image"
                            width={167}
                            height={50}
                            loading="lazy" />
                    </div>
                    <p className='body-default-copy-large'>Goldman Sachs 10,000 Small Businesses UK is an investment to help entrepreneurs create jobs and economic opportunity by providing business and management training to high-growth small business owners in the UK.</p>
                    <p className='body-default-copy-large'><a className="linkText" target="_blank" href="http://www.goldmansachs.com/citizenship/10000-small-businesses/UK/index.html" rel="noreferrer">http://www.goldmansachs.com/citizenship/10000-small-businesses/UK/index.html</a></p>
                    <h6>Why Goldman Sachs 10,000 Small Businesses UK is supporting The Gender Index:</h6>
                    <p className='body-default-copy-large'>Goldman Sachs has a long-standing history of supporting women’s economic empowerment in communities around
the world. Through our sector-leading 10,000 Small Businesses and 10,000 Women programs, we help to move the
needle for women entrepreneurs globally.</p>
                    <p className='body-default-copy-large'>The Gender Index is committed to understanding the economic, social and community impact of women
entrepreneurs in the UK. By improving visibility of the SME landscape, they know that support for women
entrepreneurs can be tailored and enhanced.</p>

                    <div className='heroBanner'>
                        {/* <img src="/images/partnerdetail.png" alt="partner_image" /> */}
                        <Image
                            src="/images/partnerdetail.png"
                            alt="partner_image"
                            width={917}
                            height={253}
                            loading="lazy"
                        />
                    </div>
                    <p className='body-default-copy-large'>“We are proud to support The Gender Index to achieve our shared mission: improving the operating environment for
women entrepreneurs in the UK, and ultimately helping to close the gender gap.”</p>
                    <p className='body-default-copy-large'><b>Charlotte Keenan</b><br/>
                        Head of the Office of Corporate Engagement International<br/>
                        Goldman Sachs</p>

                </div>
            </Layout >
        </div >
    );
}

